import SimpleIntro from "../../components/General/SimpleIntro";
import AdvancedText from "../../components/General/AdvancedText";
import AdvancesCardList from "../../components/General/AdvancesCardList";
import AdvancedIntro from "../../components/General/AdvancedIntro";

const Visas = () => {
  return (
    <section>
      <SimpleIntro urlApi="services/visas/simpleIntro" />

      <div className="container text-center">
        <div style={{ margin: "7rem auto" }}>
          <AdvancedText urlApi="services/visas/advancedText" />

          <AdvancesCardList urlApi="services/visas/visasList" />
        </div>
      </div>

      <AdvancedIntro urlApi="services/visas/advancedIntro" />
    </section>
  );
};

export default Visas;
